import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@xem/look/Renders/Field";

export default (function Mail(props){
	let { id: name, name: label, values, required, setFieldValue, tabIndex } = props || {}
	let value = values[name];
	return <>
		<Field
			{...{ onRemove: setFieldValue, inputProps: { tabIndex: tabIndex++ } }}
			{...{ className: 'Mui-textfield', component: RenderField }}
			{...{ label, name, value, required }}
		/>
	</>
})